const PORTFOLIO_QUANTITY_PATTERN = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/;

export function isValidPortfolioQuantity(value) {
    const text = value == null ? '' : String(value).trim();
    const numericValue = Number(text);
    return (
        Boolean(text)
        && PORTFOLIO_QUANTITY_PATTERN.test(text)
        && Number.isFinite(numericValue)
        && numericValue !== 0
    );
}

export function createPortfolioAttemptId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `00000000-0000-4000-8000-${Date.now().toString(16).padStart(12, '0').slice(-12)}`;
}
